import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5kyq2xcup: FaireProductEntity = {
  token: "p_q5kyq2xcup",
  type: "product",
  name: "Love You Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/e77cb0a5315bbe3f1ff093dd3699c448bd6d1e10fc7953eddb8bb2d54fa5b080.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Show your affection with our beautifully designed "Love You" greeting card. Perfect for expressing your heartfelt sentiments, this card is a versatile way to convey your love to anyone special in your life. Whether it\'s for Valentine\'s Day, a birthday, or just because, this card is ideal for spouses, significant others, family members, or friends. The elegant design and touching message make it a timeless choice for any occasion where love is the theme.\n\n•Size: A2, 5.5" x 4.25" card\n•Features: Blank interior and coordinating envelope\n•Sentiment: Love You',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:02.659Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
